import { computed, reactive, useContext } from "@nuxtjs/composition-api";
const state = reactive({
  notifications: []
});
const maxVisibleNotifications = 3;
const timeToLive = 3e3;
function useUiNotification() {
  const { app } = useContext();
  const cookieMessage = app.$vsf.$magento.config.state.getMessage();
  const send = (notification) => {
    const id = Symbol("id");
    const dismiss = () => {
      const index = state.notifications.findIndex((n) => n.id === id);
      if (index !== -1)
        state.notifications.splice(index, 1);
      app.$vsf.$magento.config.state.removeMessage();
    };
    const newNotification = {
      ...notification,
      id,
      dismiss
    };
    if (!state.notifications.some((stateNotification) => stateNotification.message === notification.message)) {
      state.notifications.push(newNotification);
    }
    if (state.notifications.length > maxVisibleNotifications) {
      state.notifications.shift();
    }
    if (!notification.persist) {
      setTimeout(dismiss, timeToLive);
    }
  };
  if (cookieMessage) {
    send(cookieMessage);
    app.$vsf.$magento.config.state.removeMessage();
  }
  return {
    send,
    notifications: computed(() => state.notifications)
  };
}
var useUiNotification_default = useUiNotification;
export * from "./useUiNotification";
export {
  useUiNotification_default as default,
  useUiNotification
};
